import { RpServiceAttributePropertyTypes } from "@enums/rp-service-attribute-property-types";

export const NON_RESTRICTED_ATTRIBUTE_PROPERTIES = [
    RpServiceAttributePropertyTypes.USER_VISIBLE_FLAG,
    RpServiceAttributePropertyTypes.USER_EDITABLE_FLAG,
    RpServiceAttributePropertyTypes.OPTIONAL_FLAG,
    RpServiceAttributePropertyTypes.CUSTOM_TOOLTIP,
    RpServiceAttributePropertyTypes.DISPLAY_FULL_VALUE
];